import React, {useEffect, useRef, useState} from "react";
import {Grid, ToggleButtonGroup, useTheme} from "@mui/material";
import {ToggleButton} from "@mui/lab";
import {BarChart} from "@mui/x-charts";
import {IDashboardStatistics, SortedItem} from "./DashboardTypes";
import {ICustomerType, IInspection, IInspectionItem} from "../../rest-data-provider/bfaTypes";
import {BfARefineUtils} from "../../utils/BfARefineUtils";
import {InspectionSpeedChart} from "./InspectionSpeedChart";

export interface InspectionItemsChartProps {
    data: IDashboardStatistics
}
export const ChartTypeByName = 'byName'
export const ChartTypeByInspector = 'byInspector'
export const ChartTypeByCustomer = 'byCustomer'
export type ChartType = typeof ChartTypeByName| typeof ChartTypeByInspector|typeof ChartTypeByCustomer;
export const InspectionItemsChart : React.FC<InspectionItemsChartProps> = ({data}) => {

    const [chartType, setChartType] = useState<ChartType>(ChartTypeByName)
    const [itemsByName, setItemsByName] = useState<SortedItem[]>([]);

    const [longestLabel, setLongestLabel] = useState<string>('')
    const [chartMarginLeft, setChartMarginLeft] = useState(0)

    const theme = useTheme();


    // const canvas = useRef(null);
    // let ctx : CanvasRenderingContext2D|null = null;
    // const writeText = (text:string, style : any = {}) => {
    //     // const { text, x, y } = info;
    //     const { fontSize = 'normal 400 12', fontFamily = 'sans-serif', color = 'black', textAlign = 'left', textBaseline='top'} = style;
    //     if(ctx) {
    //         ctx.clearRect(0,0,1000, 1000);
    //         ctx.beginPath();
    //         ctx.font = fontSize + 'px ' + fontFamily;
    //         ctx.textAlign = textAlign;
    //         ctx.textBaseline = textBaseline;
    //         ctx.fillStyle = color;
    //         ctx.letterSpacing = '0.3px'
    //
    //         ctx.fillText(text, 0, 0);
    //         ctx.stroke();
    //     }
    // }

    // useEffect(() => {
    //     alert(longestLabel)
    //     writeText(longestLabel);
    // }, [longestLabel]);

    // initialize the canvas context
    // useEffect(() => {
    //     if(canvas.current) {
    //         // dynamically assign the width and height to canvas
    //         const canvasEle : HTMLCanvasElement = canvas.current;
    //         canvasEle.width = canvasEle.clientWidth;
    //         canvasEle.height = canvasEle.clientHeight;
    //
    //         // get context of the canvas
    //         ctx = canvasEle.getContext("2d");
    //         writeText(longestLabel)
    //     }
    // }, [canvas.current, longestLabel]);

    const findCustomer = (inspectionId: number) : ICustomerType|null => {
        for (const inspection of data.inspections) {
            if(inspection.id === inspectionId) {
                return inspection.customer;
            }
        }
        return null;
    }

    let numberOfItemsInChart = 10;
    useEffect(() => {
        if(data) {
                 
            let groupedData : Partial<Record<string, IInspectionItem[]>> = {}
            if(chartType === "byName") {
                groupedData = Object.groupBy(data.inspectionItems, item => item.device.trim())
                numberOfItemsInChart = 10;
            } else if(chartType === ChartTypeByInspector) {
                groupedData = Object.groupBy(data.inspectionItems, item => item.inspector.firstName + " " + item.inspector.lastName.trim())
                numberOfItemsInChart = data.employees.length;
            } else if(chartType === ChartTypeByCustomer) {
                groupedData = Object.groupBy(data.inspectionItems, item => findCustomer(item.inspectionId)!.name)
                numberOfItemsInChart = 10;
            }

            let marginLeft = 0;
            const sortedItems : SortedItem[] = []
            for (const [key, value] of Object.entries(groupedData)) {
                // console.log(key, value?.length)

                sortedItems.push({
                    name: key,
                    count: value ? value.length : 0,
                    defectCount: value ? value.filter(item => !item.result).length : 0,
                } as SortedItem)
            }
            sortedItems.sort((a, b) => a.count - b.count).reverse()
            let countOthers = 0;
            let countOthersDefect = 0;

            const compactSortedItems = [];
            for (let i = 0; (i < numberOfItemsInChart && i < sortedItems.length); i++) {
                const textLength = BfARefineUtils.getTextWidth(sortedItems[i].name)
                if(marginLeft < textLength) {
                    marginLeft = textLength;
                    setLongestLabel(sortedItems[i].name);
                }
                compactSortedItems.push(sortedItems[i]);
            }
            setChartMarginLeft(marginLeft + 20);
            for (let i = numberOfItemsInChart; i < sortedItems.length; i++) {
                countOthers += sortedItems[i].count;
                countOthersDefect += sortedItems[i].defectCount;
            }
            if(countOthers > 0 || countOthersDefect > 0) {
                compactSortedItems.push({
                    name: 'Andere Geräte',
                    count: countOthers,
                    defectCount: countOthersDefect,
                })
            }
            setItemsByName(compactSortedItems);
            // console.log(compactSortedItems)
        }
    }, [data, chartType])

    return (
        <>
            <Grid container>
                <Grid item xs={12}>
                    <>
                        <div style={{display: 'flex', justifyContent: 'space-between', marginTop: '20px', marginLeft: '20px', marginRight: '20px'}}>
                            <h3 style={{padding: 0, margin: 0, marginRight: '10px', lineHeight: '40px'}}>Anzahl geprüfte Geräte</h3>
                            <ToggleButtonGroup
                                color="primary"
                                size={'small'}
                                value={chartType}
                                exclusive
                                onChange={(event, value) => {
                                    if (value) {
                                        setChartType(value)
                                    }

                                }}
                                aria-label="Platform"
                            >
                                <ToggleButton sx={{
                                    '&.Mui-selected': {
                                        fontWeight: 'bold'
                                    }
                                }} value={ChartTypeByName}>nach Gerätetyp</ToggleButton>
                                <ToggleButton sx={{
                                    '&.Mui-selected': {
                                        fontWeight: 'bold'
                                    }
                                }} value={ChartTypeByInspector}>nach Prüfer</ToggleButton>
                                <ToggleButton sx={{
                                    '&.Mui-selected': {
                                        fontWeight: 'bold'
                                    }
                                }} value={ChartTypeByCustomer}>nach Kunde</ToggleButton>
                            </ToggleButtonGroup>
                        </div>

                        {itemsByName.length === 0 && (
                            <h3 style={{color: 'grey', textAlign: 'center'}}>Für die Auswahl sind keine Daten vorhanden</h3>
                        )}

                        {itemsByName && itemsByName.length > 0 && (
                            <BarChart
                                sx={{
                                    marginBottom: '10px',
                                    '& .MuiBarLabel-root': {
                                        fontWeight: 'bold',
                                        fill: 'red',

                                        // transform: 'translateX(100px)'
                                    }
                                }}
                                margin={{left: chartMarginLeft}}
                                dataset={itemsByName}
                                yAxis={[{scaleType: 'band', dataKey: 'name',}]}
                                xAxis={[{label: 'Anzahl'}]}
                                series={[{
                                    dataKey: 'count',
                                    stack: 'test',
                                    label: 'Anzahl i.O.',
                                    id: 'count',
                                    color: theme.palette.primary.main
                                },
                                    {
                                        dataKey: 'defectCount',
                                        stack: 'test',
                                        label: 'Anzahl Defekt',
                                        color: theme.palette.secondary.main
                                    }]}
                                layout="horizontal"
                                barLabel={(item, context) => {
                                    // console.log(item, context)
                                    if (item.seriesId === 'count' && context.bar.width > 45) {
                                        return "⌀ " + ((itemsByName[item.dataIndex].defectCount / itemsByName[item.dataIndex].count) * 100).toFixed(1) + '%';
                                    }
                                    return '';
                                }}
                                height={500}
                            />
                        )}
                    </>
                </Grid>
                {/*<Grid item xs={4}>*/}
                {/*    <InspectionSpeedChart data={data}></InspectionSpeedChart>*/}
                {/*</Grid>*/}
            </Grid>


            {/*<canvas width={'1000px'} ref={canvas}>*/}
            {/*</canvas>*/}
        </>
    )
}